import { useSyncExternalStore } from 'react';

const NAV_EVENT = 'pacmaster:navigation';

let patched = false;

function dispatchNavigationEvent() {
  try {
    window.dispatchEvent(new Event(NAV_EVENT));
  } catch {
    // no-op
  }
}

function ensureHistoryPatched() {
  if (patched || typeof window === 'undefined') return;
  patched = true;

  const originalPushState = window.history.pushState.bind(window.history);
  const originalReplaceState = window.history.replaceState.bind(window.history);

  window.history.pushState = function patchedPushState(...args) {
    const out = originalPushState(...args);
    dispatchNavigationEvent();
    return out;
  };

  window.history.replaceState = function patchedReplaceState(...args) {
    const out = originalReplaceState(...args);
    dispatchNavigationEvent();
    return out;
  };
}

function subscribe(onStoreChange: () => void) {
  if (typeof window === 'undefined') return () => {};

  ensureHistoryPatched();
  window.addEventListener('popstate', onStoreChange);
  window.addEventListener(NAV_EVENT, onStoreChange);

  return () => {
    window.removeEventListener('popstate', onStoreChange);
    window.removeEventListener(NAV_EVENT, onStoreChange);
  };
}

function getSnapshot() {
  if (typeof window === 'undefined') return '/';
  return window.location.pathname || '/';
}

export function useBrowserPathname(): string {
  return useSyncExternalStore(subscribe, getSnapshot, () => '/');
}
